<style>
  .btn_terciario {
    background: rgba(15, 123, 166, 0.06);
    color: var(----color-blue, #0f7ba6);
    padding: 0.9rem 3.5rem;
    border-radius: 2rem;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2rem;
    text-align: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    align-items: center;
    &:hover

  {
    color: var(--color-white);
    background: linear-gradient( 0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3) ), var(--color-blue);
  }
  }
</style>
<header-govbr></header-govbr>
<!-- CABEÇALHO -->
<header aria-label="Cabeçalho principal">
  <section class="container">
    <!-- HEADER MENU E LOGO CONVIVA -->
    <div class="item-menu">
      <a href="javascript:void(0)"
         id="btn-abrir-menu"
         class="icon-nav"
         (click)="ExpandirMenu()"
         title="Menu"
         aria-label="Abrir menu de navegação">
      </a>

      <a
        href="javascript:void(0)"
        routerLink="/"
        class="logo-brasao"
        aria-label="Ir para a página inicial"
      >
        <img
          src="../../../../assets/img/logo-coviva-sp-brasao.svg"
          alt="Conviva"
          title="Conviva"
          class="mobile-logo"
        />
        <img
        src="../../../../assets/img/logo-conviva-sp.svg"
        alt="Conviva"
        title="Conviva"
        class="desktop-logo"
      />
      </a>
    </div>

    <!-- PERFIL E NOTIFICAÇÃO -->
    <div class="conteudo-perfil">
      <modal-alterar-perfil *ngIf="this.userLogado!.perfis.length > 1"></modal-alterar-perfil>

      <div class="icon-add-chamado"
           *ngIf="this.userLogado?.funcionalidades?.includes(2)">
        <a href="javascript:void(0)"
           routerLink="/cadastrar-chamados"
           class="add-chamado"
           title="Adicionar Chamado"
           aria-label="Adicionar chamado">
          Adicionar Chamado
        </a>
      </div>
      @if(mostrarConteudoParaPerfils([1634,1477 ,1632]) ){
      <relogio-ponto-component></relogio-ponto-component>

      }

      <sino-component *ngIf="this.userLogado?.funcionalidades?.includes(16)"
                      aria-label="Notificações"></sino-component>

      <a href="javascript:void(0)"
         routerLink="/perfil"
         class="perfil"
         aria-label="Ir para o perfil do usuário">
        <img src="../../../../assets/img/elemento/avatarPerfilAluno.jpg"
             alt="Perfil"
             title="Perfil"
             aria-label="Ir para o perfil do usuário" />
      </a>

      <a href="javascript:void(0)"
         class="btn-logout"
         aria-label="Sair da aplicação"
         title="Sair"
         alt="Sair"
         (click)="logout()">
        Sair
      </a>
    </div>
  </section>
</header>

<!-- MENU LATERAL -->
<aside class="sidebar-menu" aria-label="Menu lateral">
  <nav>
    <div class="perfil-menu">
      <a href="javascript:void(0)"
         routerLink="/perfil"
         class="perfil"
         aria-label="Ir para o perfil do usuário">
        <img src="../../../../assets/img/elemento/avatarPerfilAluno.jpg"
             alt="Perfil"
             title="Perfil do usuário" />
      </a>
      <a class="sidebar-menu-fechar"
         title="Fechar"
         (click)="FecharMenu()"
         aria-label="Fechar menu lateral">
      </a>
    </div>
    <div class="identidade-menu">
      <p>
        <b>Olá,</b>
        {{
          this.userLogado?.flPsicologo
            ? "Psicólogo"
            : this.atribuicoesLogin.NomePerfil
        }}<br />
        <b>
          {{
            this.userLogado?.flPsicologo
              ? this.userLogado?.nome
              : this.atribuicoesLogin.Nome
          }}
        </b>
      </p>
    </div>

    <ul class="link-list">
      <!-- class="active"  -->
      <li>
        <a *ngIf="this.userLogado?.codigoPerfil != 1656"
           href="javascript:void(0)"
           aria-label="Ir para a página inicial"
           routerLink="/"
           alt="Home"
           title="Home"
           (click)="FecharMenu()">
          Home
        </a>
      </li>

      <li *ngIf="this.userLogado?.codigoPerfil != 1656">
        <!-- Ocorrência -->
        <input type="checkbox"
               checked
               class="nav-dropdown"
               id="nav-dropdown-ocorrencia" />
        <label for="nav-dropdown-ocorrencia"> Ocorrência </label>
        <div class="opcoes-dropdown-itens">
          <a *ngIf="this.userLogado?.funcionalidades?.includes(2)"
             href="javascript:void(0)"
             routerLink="/cadastrar-chamados"
             title="Adicionar Chamado"
             aria-label="Abrir menu de Ocorrências"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Adicionar Chamado
          </a>
          <a *ngIf="this.userLogado?.funcionalidades?.includes(2)"
             href="javascript:void(0)"
             routerLink="/adicionar-nao-ocorrencia"
             title="Adicionar Chamado"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Adicionar Não Ocorrência
          </a>
          <a href="javascript:void(0)"
             routerLink="/chamados-unificado-list"
             title="Consultar Chamados"
             aria-label="Consultar Chamados"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Consultar Chamados
          </a>
          <a href="javascript:void(0)"
             routerLink="/buscar-alunos"
             title="Buscar Estudantes com Ocorrências"
             aria-label="Buscar estudantes com ocorrências"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Buscar Estudantes com Ocorrências
          </a>
          <a href="javascript:void(0)"
             routerLink="/listar-chamados"
             title="Estudantes com Ocorrências Registradas"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Estudantes com Ocorrências Registradas
          </a>
          <a href="javascript:void(0)"
             routerLink="/chamados-list"
             title="Tela de Chamados"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Tela de Chamados
          </a>
        </div>
      </li>
      <!-- End Ocorrência -->

      <!-- Civico Militar -->
      <li *ngIf="userPodeVisualizarCivicoMilitar()">
        <input
          type="checkbox"
          checked
          class="nav-dropdown"
          id="nav-dropdown-civico"
        />
        <label for="nav-dropdown-civico"> Civico Militar </label>
        <div class="opcoes-dropdown-itens">
          <a href="javascript:void(0)"
            routerLink="/civico-militar"
            title="Relatório"
            aria-label="Relatório"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="this.userLogado?.funcionalidades?.includes(29)">
            Relatório
          </a>
          <!-- <a href="javascript:void(0)"
            routerLink="/civico-militar/fato-aluno/atualizar-fatos-nova-resolucao"
            title="Atualizar fatos Cívico Militar nova resolução"
            aria-label="Atualizar fatos Cívico Militar nova resolução"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="this.userLogado?.codigoPerfil == Perfil.GestorConviva">
            Atualizar fatos Cívico Militar nova resolução
          </a> -->
        </div>
      </li>
      <!-- End POC -->

      <li *ngIf="((this.userLogado?.codigoPerfil != 1656 && podeVisualizarMenuPsicologos) || this.userLogado?.codigoPerfil == 1634)">
        <!-- Psicólogos -->
        <input type="checkbox"
               checked
               class="nav-dropdown"
               id="nav-dropdown-psicologos" />
        <label for="nav-dropdown-psicologos"> Psicólogos </label>

        <div class="opcoes-dropdown-itens">
          <a
            href="javascript:void(0)"
            routerLink="/relatorio-pec-psicologo.component"
            title="Relatório"
            aria-label="Relatório"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="temFuncionalidade([34, 35])"
          >
            Relatório
          </a>
          <a href="javascript:void(0)"
             title="Agendamento Psicólogos"
             aria-label="Agendamento Psicólogos"
             routerLinkActive="active"
             (click)="AbrirModalAgendamento()"
             *ngIf="this.userLogado?.funcionalidades?.includes(1)">
            Agendamento Psicólogos
          </a>

          <a href="javascript:void(0)"
             routerLink="/atendimento-psicologo"
             title="Atendimento Psicologos"
             aria-label="Atendimento Psicólogos"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(1)">
            Atendimento Psicólogos
          </a>
          <a href="javascript:void(0)"
            routerLink="/relatorio/atividade"
            title="Relatório de Atividade do Psicólogo"
            aria-label="Relatório de Atividade do Psicólogo"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="this.userLogado?.codigoPerfil == Perfil.CoordenadorPsicologo || this.userLogado?.codigoPerfil == Perfil.GestorConviva">
            Relatório de Atividade do Psicólogo
          </a>
        </div>
      </li>
      <li>
        <!-- End Psicólogos -->

      <!-- Painéis -->
      <li>
        <!-- Painéis -->
        <input type="checkbox"
               checked
               class="nav-dropdown"
               id="nav-dropdown-paineis"
               aria-label="Abrir menu de Painéis" />
        <label for="nav-dropdown-paineis"> Painéis </label>
        <div class="opcoes-dropdown-itens">
          <a *ngIf="this.userLogado?.codigoPerfil != 1656"
             href="javascript:void(0)"
             routerLink="/dashboard"
             title="Painel Geral"
             aria-label="Painel Geral"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Painel Geral
          </a>
          <a href="javascript:void(0)"
             routerLink="/avaliacao-visita-fiscal"
             title="Painel Avaliação Fiscal"
             aria-label="Painel Avaliação Fiscal"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(23)">
            Painel de Avaliação do Fiscal
          </a>
          <a href="javascript:void(0)"
             routerLink="/dashboard-visitas-poc"
             title="Painel de Atividade do POC"
             aria-label="Painel de Atividade do POC"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(22)">
            Painel de Atividade do POC
          </a>
          <a href="javascript:void(0)"
             routerLink="/dashboard-visitas-psicologo"
             title="Painel de Atividade do psicólogo - Antigo"
             aria-label="Painel de Atividade do psicólogo - Antigo"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(24)">
            Painel de Atividade do psicólogo / Antigo
          </a>
           <a
            href="javascript:void(0)"
            routerLink="/painel-atividade-coordenador-psicologo"
            title="Painel de Atividade do Coordenador"
            aria-label="Painel de Atividade do Coordenador"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="this.userLogado?.funcionalidades?.includes(43)"
          >
            Painel de Atividade do Coordenador
          </a>
          <a href="javascript:void(0)"
             routerLink="/painel-atividade-psicologo"
             title="Painel de Atividade do Psicólogo"
             aria-label="Painel de Atividade do Psicólogo"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(24)">
            Painel de Atividade do Psicólogo
          </a>

          <a *ngIf="this.userLogado?.codigoPerfil != 1656"
             href="javascript:void(0)"
             routerLink="/dashboard-nao-ocorrencia"
             title="Painel de Não Ocorrência"
             aria-label="Painel de Não Ocorrência"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Painel de Não Ocorrência
          </a>
          <a href="javascript:void(0)"
             routerLink="/dashboard-reincidencia"
             title="Painel de Reincidência"
             aria-label="Painel de Reincidência"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(2)">
            Painel de Reincidência
          </a>
        </div>
      </li>
      <!-- End Painéis -->
      <!-- POC -->
      <li *ngIf="this.userLogado?.funcionalidades?.includes(19)">
        <input
          type="checkbox"
          checked
          class="nav-dropdown"
          id="nav-dropdown-poc"
        />
        <label for="nav-dropdown-poc"> POC </label>
        <div class="opcoes-dropdown-itens">
          <a href="javascript:void(0)"
            routerLink="/relatorio-pec"
            title="Relatório"
            aria-label="Relatório"
            routerLinkActive="active"
            (click)="FecharMenu()"
            *ngIf="this.userLogado?.funcionalidades?.includes(36)">
            Relatório
          </a>
          <a href="javascript:void(0)"
             routerLink="/"
             title="Validação de Atividades do POC"
             aria-label="Validação de Atividades do POC"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Validação de Atividades do POC
          </a>
          <a href="javascript:void(0)"
             routerLink="/"
             title="Validação de Atividades do POC / Antigo"
             aria-label="Validação de Atividades do POC / Antigo"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Validação de Atividades do POC / Antigo
          </a>
          <a href="javascript:void(0)"
             routerLink="/filtro-visitas-professor"
             title="Visita POC"
             aria-label="Visita POC"
             routerLinkActive="active"
             (click)="FecharMenu()"
             *ngIf="this.userLogado?.funcionalidades?.includes(19)">
            Registro da Atividade do POC
          </a>
        </div>
      </li>
       <!-- End POC -->

       <!-- Plano de Melhoria -->
       <li *ngIf="
               (this.userLogado?.funcionalidades?.includes(38) && temPmceAtivo)
            || (this.userLogado?.funcionalidades?.includes(39) && temPmceAtivo)
            || (this.userLogado?.funcionalidades?.includes(40) && temPlanoContingenciaAtivo)
            || (this.userLogado?.funcionalidades?.includes(42))">
        <input
          type="checkbox"
          checked
          class="nav-dropdown"
          id="nav-dropdown-planos"
        />
        <label for="nav-dropdown-planos"> Planos </label>
          <div class="opcoes-dropdown-itens">
            <a href="javascript:void(0)"
              routerLink="/plano-melhoria/consulta"
              title="Plano da Melhoria de Convivência Escolar - PMCE - Consulta"
              aria-label="Plano da Melhoria de Convivência Escolar - PMCE - Consulta"
              routerLinkActive="active"
              *ngIf="this.userLogado?.funcionalidades?.includes(38) && temPmceAtivo">
              Plano da Melhoria de Convivência Escolar - PMCE - Consulta
            </a>
            <a href="javascript:void(0)"
              routerLink="/plano-melhoria/cadastro"
              title="Plano da Melhoria de Convivência Escolar - PMCE - Cadastro"
              aria-label="Plano da Melhoria de Convivência Escolar - PMCE - Cadastro"
              routerLinkActive="active"
              (click)="FecharMenu()"
              *ngIf="this.userLogado?.funcionalidades?.includes(39) && temPmceAtivo">
              Plano da Melhoria de Convivência Escolar - PMCE - Cadastro
            </a>
            <a href="javascript:void(0)"
              (click)="navegarPlanoContingencia()"
              title="Plano de Contingência"
              aria-label="Plano de Contingência"
              routerLinkActive="active"
              *ngIf="this.userLogado?.funcionalidades?.includes(40) && temPlanoContingenciaAtivo">
              Plano de Contingência
            </a>
            <a href="javascript:void(0)"
              routerLink="/parametros-periodo"
              title="Configuração de vigências"
              aria-label="Configuração de vigências"
              routerLinkActive="active"
              (click)="FecharMenu()"
              *ngIf="this.userLogado?.funcionalidades?.includes(42)">
              Configuração de vigências
          </a>
            <a href="javascript:void(0)"
              routerLink="/plano-melhoria/correcao-vinculo"
              title="Correção de vínculo PMCE"
              aria-label="Correção de vínculo PMCE"
              routerLinkActive="active"
              (click)="FecharMenu()"
              *ngIf="this.userLogado?.funcionalidades?.includes(42)">
              Correção de vínculo PMCE
          </a>

        </div>
      </li>
      <!-- End Plano de Melhoria -->

      @if(userLogado?.codigoPerfil == 1634 || userLogado?.codigoPerfil == 1632){
      <li>
        <input
          type="checkbox"
          checked
          class="nav-dropdown"
          id="nav-dropdown-registrar-entrada-escola"
        />
        <label for="nav-dropdown-registrar-entrada-escola">
          Entrada / Saída da Escola
        </label>
        <div class="opcoes-dropdown-itens">
          <a href="javascript:void(0)"
             title="Registrar Entrada"
             aria-label="Registrar Entrada"
             routerLinkActive="active"
             class="registro-entrada-escola"
             (click)="onClickRegistrarEntradaMenu()">
            Registrar Entrada
          </a>
          <a href="javascript:void(0)"
             title="Registrar Saída"
             aria-label="Registrar Saída"
             routerLinkActive="active"
             class="registro-saida-escola"
             (click)="abrirModalRelogioPontoSaida()">
            Registrar Saída
          </a>
        </div>
      </li>
      }

      <!-- Perfis do Conviva -->
      <li *ngIf="this.userLogado?.funcionalidades?.includes(10)">
        <input
          type="checkbox"
          checked
          class="nav-dropdown"
          id="nav-dropdown-perfis-conviva"
        />
        <label for="nav-dropdown-perfis-conviva">Perfis do Conviva</label>
        <div class="opcoes-dropdown-itens">
          <a href="javascript:void(0)"
             routerLink="/perfil-conviva-manage"
             title="Perfis Habilitados no Conviva"
             aria-label="Perfis Habilitados no Conviva"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Perfis Habilitados
          </a>
          <a href="javascript:void(0)"
             routerLink="/perfil-manage"
             title="Adicionar Função ao Perfil"
             aria-label="Adicionar Função ao Perfil"
             routerLinkActive="active"
             (click)="FecharMenu()">
            Adicionar Função ao Perfil
          </a>
        </div>
      </li>

      <li *ngIf="this.userLogado?.DadosUsuario?.[0]?.Cpf === 24143302870 || this.userLogado?.DadosUsuario?.[0]?.Cpf === 39227241833 || this.userLogado?.DadosUsuario?.[0]?.Cpf === 37958497806">
        <a href="javascript:void(0)"
           routerLink="/funcoes-admin"
           title="Funções Admin"
           aria-label="Funções Admin"
           routerLinkActive="active"
           (click)="FecharMenu()">
          Funções Admin
        </a>
      </li>
      <!-- <li>
        <a href="javascript:void(0)" routerLink="/perfil" title="Perfil" routerLinkActive="active" (click)="FecharMenu()">
          Perfil
        </a>
      </li> -->
      <!-- @if(userLogado?.codigoPerfil === 1477){
      <li>
        <a
          href="javascript:void(0)"
          routerLink="/gerenciamento-email"
          title="Gerenciamento de E-mails"
          routerLinkActive="active"
          (click)="FecharMenu()"
        >
          Gerenciamento de E-mails
        </a>
      </li>
      } -->
      <li *ngIf="this.userLogado?.funcionalidades?.includes(17)">
        <a
          href="javascript:void(0)"
          routerLink="/consolidado"
          title="Perfil"
          aria-label="Perfil"
          routerLinkActive="active"
          (click)="FecharMenu()"
        >Relatórios</a>
      </li>
      <!-- End Relatórios -->

      <li>
        <a href="javascript:void(0)"
           title="Sair"
           aria-label="Sair da aplicação"
           (click)="logout()">
          Sair
        </a>
      </li>

      <li>
        <p style="
            margin-top: 20px;
            font-size: 12px !important;
            text-align: center;
          ">
          <b style="font-size: 12px !important">Versão:</b> {{ this.versao }}
        </p>
      </li>

    </ul>
  </nav>
</aside>

<app-modal *ngIf="showModalAgendamento">
  <div class="container-conviva form-registro modal-envolvidos">
    <div>
      <h1 class="titulo-page">Agendamentos em Aberto</h1>
    </div>
    <div class="descricao-modal-excluir">
      <span>
        Existem {{ this.quantidadeAgendamentosAbertos }} agendamentos em aberto.
      </span>
    </div>
    <div class="container-btns">
      <input type="button"
             (click)="FecharModalPopUp()"
             class="btn_outline"
             value="Fechar" />
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalAgendamentoPsicologo">
  <div class="container-conviva form-registro modal-envolvidos modal-visita-psicologo">
    <div class="header-modal-filtro">
      <h1 class="titulo-page">Deseja agendar:</h1>
      <a class="btn-fechar-modal" (click)="FecharModalAgendamento()">fechar</a>
    </div>

    <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
      <div class="container-btns">
        <input type="button"
               [routerLink]="['/agendamento-visita-prevencao']"
               class="btn_outline"
               value="Prevenção"
               (click)="FecharModalAgendamento()" />
        <input type="button"
               class="btn_primary"
               [routerLink]="['/agendamento-psicologos']"
               value="Acolhimento"
               (click)="FecharModalAgendamento()" />
        <input type="button"
               (click)="FecharModalAgendamento()"
               class="btn_terciario"
               value="Fechar" />
      </div>
    </div>
  </div>
</app-modal>
